import React, { useEffect, useState } from "react";
import { Card, Table, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { onProductDelete, onProducts } from "../../redux/homeAction";
import "./Product.css";
import CustomPagination from "../CustomPagination";

const Products = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [page, setPage] = useState(0);
  const [limit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const getOnProducts = useSelector((state) => state.home.getOnProducts);
  const getOnProductDelete = useSelector(
    (state) => state.home.getOnProductDelete,
  );

  // Fetch products whenever page, delete, or search changes
  useEffect(() => {
    dispatch(onProducts(setLoading, page + 1, limit, search));
  }, [getOnProductDelete, page, search, dispatch]);

  const productDeleteHandler = (productId) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      dispatch(onProductDelete(setLoading, productId));
    }
  };

  const formatCategories = (categories) => {
    if (!categories || categories.length === 0) return "-";
    return categories
      .map((cat) => (cat?.name ? cat.name : cat.$oid || "-"))
      .join(", ");
  };

  const handlePageClick = (selectedPage) => {
    setPage(selectedPage.selected);
  };

  const totalPages = Math.ceil((getOnProducts?.totalProducts || 0) / limit);

  return (
    <Card className="mt-3">
      <Card.Header className="d-flex justify-content-between align-items-center flex-wrap">
        <h5 className="mb-2 mb-sm-0">📦 Products</h5>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <Form.Control
            type="text"
            placeholder="Search products..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ width: 200 }}
          />
          <Link to="/add-single-catalog">
            <Button variant="primary">+ Add Product</Button>
          </Link>
        </div>
      </Card.Header>

      <Card.Body>
        <h6>Total Products: {getOnProducts?.totalProducts || 0}</h6>
        <div style={{ overflowX: "auto" }}>
          <Table
            striped
            bordered
            hover
            responsive
            className="text-center align-middle"
          >
            <thead className="table-dark sticky-top">
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Rating</th>
                <th>Price</th>
                <th>Max/User</th>
                <th>Categories</th>
                <th>Variants Stock</th>
                <th>SKU</th>
                <th>Created At</th>
                <th>Updated At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {getOnProducts?.products?.map((product, index) => (
                <tr key={product._id}>
                  <td>{page * limit + index + 1}</td>
                  <td>{product.name}</td>
                  <td>{product.rating}</td>
                  <td>{product.price}</td>
                  <td>{product.maxPerUser}</td>
                  <td>{formatCategories(product.categories)}</td>
                  <td>
                    {product.variants && product.variants.length > 0 ? (
                      <Table bordered size="sm">
                        <thead>
                          <tr>
                            <th>Color / Size</th>
                            {Array.from(
                              new Set(product.variants.map((v) => v.size)),
                            ).map((size) => (
                              <th key={size}>{size}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {Array.from(
                            new Set(product.variants.map((v) => v.color)),
                          ).map((color) => (
                            <tr key={color}>
                              <td>
                                <div
                                  style={{
                                    display: "inline-block",
                                    width: 16,
                                    height: 16,
                                    backgroundColor: color,
                                    border: "1px solid #000",
                                    marginRight: 4,
                                  }}
                                ></div>
                                {color}
                              </td>
                              {Array.from(
                                new Set(product.variants.map((v) => v.size)),
                              ).map((size) => {
                                const variant = product.variants.find(
                                  (v) => v.color === color && v.size === size,
                                );
                                return (
                                  <td key={size}>
                                    {variant ? variant.stock : 0}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    ) : (
                      <span>{product.stock}</span>
                    )}
                  </td>
                  <td>{product.sku}</td>
                  <td>{new Date(product.createdAt).toLocaleDateString()}</td>
                  <td>{new Date(product.updatedAt).toLocaleDateString()}</td>
                  <td>
                    <Button
                      variant="primary"
                      size="sm"
                      className="me-1 mb-1"
                      onClick={() =>
                        navigate(
                          `/add-product?data=${encodeURIComponent(
                            JSON.stringify({
                              type: "view",
                              productId: product._id,
                            }),
                          )}`,
                        )
                      }
                    >
                      View
                    </Button>

                    <Button
                      variant="warning"
                      size="sm"
                      className="me-1 mb-1"
                      onClick={() =>
                        navigate(
                          `/add-product?data=${encodeURIComponent(
                            JSON.stringify({
                              type: "edit",
                              productId: product._id,
                            }),
                          )}`,
                        )
                      }
                    >
                      Edit
                    </Button>

                    <Button
                      variant="danger"
                      size="sm"
                      className="mb-1"
                      onClick={() => productDeleteHandler(product._id)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        {totalPages > 1 && (
          <CustomPagination
            page={page}
            totalPages={totalPages}
            onPageChange={(selectedPage) => setPage(selectedPage.selected)}
          />
        )}
      </Card.Body>
    </Card>
  );
};

export default Products;
